'use client';

import Image from "next/image";
import Link from "next/link";
import GradientLogo from '@/components/GradientLogo';

export default function AuthLayout(
  {
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      {/* Pages: Sign In: Boxed */}

      {/* Page Container */}
      <div
        id="page-container"
        className="mx-auto flex min-h-screen w-full min-w-[320px] flex-col bg-gray-100 dark:bg-gray-900 dark:text-gray-100"
      >
        {/* Page Content */}
        <main id="page-content" className="flex max-w-full flex-auto flex-col">
          <div className="relative mx-auto flex min-h-screen w-full max-w-10xl items-center justify-center overflow-hidden p-4 lg:p-8">
            {/* Sign In Section */}
            <section className="w-full max-w-xl py-6">
              {/* Header */}

              <header className="mb-10 text-center">
                <div className="flex justify-center mb-4">
                  <Link href="/" className="p-6">
                    <GradientLogo size="large" />
                  </Link>
                </div>
              </header>

              {children}

              {/* Footer */}
              <div className="mt-6 text-center text-sm">
                <span className="text-blue-600 font-medium">EvidenceSync</span> | Powered by
                <a
                  href="https://intelligentbiopharma.com"
                  className="font-medium text-blue-600 hover:text-blue-400 dark:text-blue-400 dark:hover:text-blue-300"
                >
                  &nbsp;Intelligent Biopharma
                </a>
              </div>
              {/* END Footer */}
            </section>
            {/* END Sign In Section */}
          </div>
        </main>
        {/* END Page Content */}
      </div>
      {/* END Page Container */}

      {/* END Pages: Sign In: Boxed */}
    </>
  );
}
